// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiDenial {
    static getAttributeTypeMap() {
        return PharmacyBiDenial.attributeTypeMap;
    }
}
PharmacyBiDenial.discriminator = undefined;
PharmacyBiDenial.additionalProperties = false;
PharmacyBiDenial.attributeTypeMap = [
    {
        "name": "date",
        "baseName": "date",
        "type": "string"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "string"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "reason",
        "baseName": "reason",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiDenial.js.map